export {
    createSearchParameters
};

function createSearchParameters(searchObject){

    var queryParameter = encodeData(searchObject);
    return queryParameter;
}


function encodeData(data) {

    var searchQuery = "";
    
    Object.keys(data).map(function(key) {
        if(data[key] && data[key] != ""){
            var singleQuery = encodeURIComponent(key) + "=" + encodeURIComponent(data[key]) + "&";
            searchQuery += singleQuery;
        }
    });

    return searchQuery;
} 